import React, { Component } from 'react'
import styled from 'styled-components'
import Slider from '../../UI/Slider'
import Tab from '../Tabs/Tab'
import Tabs from '../Tabs'
import Typography from '../Typography'
import PropTypes from 'prop-types'
import { device } from '../../../utils/helpers'

const Wrapper = styled.section`
  width: 100%;
  display: flex;
  flex-direction: ${props => props.reverseMobile ? 'column-reverse' : 'column'};

  @media ${device.laptop} {
    display: grid;
    width: 100%;
    grid-template-columns: 50% 50%;
    grid-template-areas: ${props => props.reverse ? `'slider content'` : `'content slider'`};
    height: 580px;
  }
`

const Content = styled.div`
  padding: 3.5rem 1.5rem;
  padding-bottom: ${props => props.customize && '6rem'};
  background-color: #f3f3f3;
  grid-area: content;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media ${device.laptop} {
    padding: ${props => props.customize ? '0 2.5VW' : '2.5rem 4.5rem'};
    padding-bottom: ${props => props.customize ? '7rem' : '0'};
  }

  @media ${device.laptopM} {
    padding: ${props => props.customize ? '0 2.5VW' : '2.5rem 4.5rem'};
  }

  @media ${device.laptopL} {
    padding: ${props => props.customize ? '0 3.3333333333333335VW' : '5rem 7.5rem'};
  }

  @media ${device.desktop} {
    padding: ${props => props.customize ? '0 6.25VW' : '5rem 7.5rem'};
  }
`

const SliderContainer = styled.div`
  width: 100%;
  grid-area: slider;
`

const Para = styled.p`
  font-size: 21px;

  @media ${device.laptop} {
    font-size: 16px;
  }

  @media ${device.laptopM} {
    font-size: 18px;
  }

  @media ${device.laptopL} {
    font-size: 21px;
  }
`

class TabSlider extends Component {
  handleSlideChange (index) {
    this.sliderWrapper.slider.slickGoTo(index)
  }

  render () {
    const { slides, title, children, tabs, customize, ...props } = this.props
    return (
      <Wrapper {...props}>
        <Content customize={customize}>
          {!customize && children}
          <Typography padding='0 0 1.2rem 0' variant='h3' type='title'>
            {title}
          </Typography>
          <Tabs>
            {tabs.map(({ title, content, goToSlideIndex }) =>
              <Tab key={title} title={title} handleSlideChange={this.handleSlideChange.bind(this, goToSlideIndex)}>
                <Para>
                  {typeof content === 'string' ? content.split(';').map(line => <span>{line} <br /></span>) : content}
                </Para>
              </Tab>
            )}
          </Tabs>
          {customize && children}
        </Content>
        <SliderContainer>
          <Slider autoplay slides={slides} dots={false} ref={sliderWrapper => (this.sliderWrapper = sliderWrapper)} />
        </SliderContainer>
      </Wrapper>
    )
  }
}

TabSlider.propTypes = {
  /**
   * Slides for the slider
   */
  slides: PropTypes.array.isRequired,
  /**
   * Title of the tabs section
   */
  title: PropTypes.string,
  /**
   * The list of tabs and their content
   */
  tabs: PropTypes.arrayOf(PropTypes.object).isRequired,
  /**
   * Switches order of slide section and content
   */
  reverse: PropTypes.bool
}

export default TabSlider



// WEBPACK FOOTER //
// ./src/components/UI/TabSlider/index.js